<div class="container">
    <h1 class="page-title"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">
  <span class="icon"><i class="fas fa-city" aria-hidden="true"></i></span>{{ 'DHLCityMaintenance.Header' | translate }}
  </h1>

  <p-card>
    <p-accordion>
      <p-accordionTab
        header="{{ 'Common.Form.Header' | translate }}"
        [(selected)]="isSearchFormOpen">

        <!-------------------------------------- Query Form ---------------------------------------------->
        <form [formGroup]="searchFormGroup" (ngSubmit)="searchBtnClick()">
          <div class="p-fluid formgrid grid">

            <!-------------------------------------- AwbNumber Slot ---------------------------------------------->
            <div class="col-6 field">
              <label>{{ 'DHLCityMaintenance.Form.AwbNumber' | translate }}</label>
              <p-chips formControlName="awbNumberList" [(ngModel)]="searchParams.awbNumberList" separator=","
                       (onAdd)="chipsAdd($event, 'awbNumberList')"></p-chips>
            </div>

          </div>

          <!-------------------------------------- Form Button ---------------------------------------------->
          <div>

             <!-------------------------------------- Query Button ---------------------------------------------->
            <button
              pButton
              type="submit"
              label="{{ 'Common.Button.Search' | translate }}"></button>

            <!-------------------------------------- Reset Button ---------------------------------------------->
            <button
              pButton
              type="reset"
              label="{{ 'Common.Button.Reset' | translate }}"
              class="p-button-secondary ml-2"></button>

          </div>

        </form>
      </p-accordionTab>
    </p-accordion>

    <!-------------------------------------- Table ---------------------------------------------->
    <p-table
      #table
      laasDataTableSetting
      [tableKey]="preferenceKey"
      [defaultColumns]="tableColumns"
      (setPageSize)="setPageSize($event)"
      [value]="tableData"
      [loading]="isLoading"
      [resizableColumns]="true"
      [reorderableColumns]="true"

      [scrollable]="true"
      scrollHeight="500px"
      scrollDirection="both"

      [(selection)]="selectedRow"
      selectionMode="single"

      [lazy]="true"
      (onPage)="onTablePageChanging($event)"
      (onSort)="onTableSorting($event)"
      [resetPageOnSort]="false"

      [paginator]="true"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{{ 'Common.Table.PageSummary' | translate}}"
      [rows]="this.pageInfo.pageSize"
      [rowsPerPageOptions]="[5, 10, 20]"
      [totalRecords]="this.pageInfo.totalRecords"
      dataKey="awbNumber"
      editMode="row"
      class="datatable"
      styleClass="p-datatable-gridlines p-datatable-stripped mt-2 white-space: nowrap;">

      <!-------------------------------------- Table Caption Part ---------------------------------------------->
      <ng-template pTemplate="caption">

        <!-------------------------------------- Display Column List ---------------------------------------------->
        <laas-table-column-toggle
            [optionsColumn]="tableColumns"
            [dataTable]="table"
          >
          </laas-table-column-toggle>

        <!-------------------------------------- Save Button ---------------------------------------------->
        <button
          pButton
          class="p-button-raised ml-2"
          label="{{ 'Common.Button.Save' | translate }}"
          icon="fas fa-save"
          [disabled]="!isInEditMode"
          (click)="saveChanges()"></button>

        <!-------------------------------------- Restore Button ---------------------------------------------->
        <button
          pButton
          class="p-button-secondary p-button-raised ml-2"
          label="{{ 'DHLCityMaintenance.Table.Button.Restore' | translate }}"
          icon="fas fa-sync-alt"
          [disabled]="!isInEditMode"
          (click)="restoreTableDate()"></button>

        <!-------------------------------------- Edit Button ---------------------------------------------->
        <button
          pButton
          style="color: white"
          class="p-button-warning p-button-raised ml-2"
          label="{{ isInEditMode ? ( 'Common.Button.Cancel' | translate ) : ( 'Common.Button.Edit' | translate ) }}"
          icon="fas fa-pen"
          (click)="switchEditMode()"></button>
      </ng-template>

      <!-------------------------------------- Table Column Group Part ---------------------------------------------->
      <!---------------------------- Make columns as a group for horizontal scroll ---------------------------------------------->
      <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
          <col *ngFor="let col of columns" [style]="{ width: col.width + 'px' }">
        </colgroup>
      </ng-template>

      <!-------------------------------------- Table Header Part ---------------------------------------------->
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" pReorderableColumn pResizableColumn
            [pSortableColumn]="col.field"
            [pSortableColumnDisabled]="!col.sort"
            scope="col" [attr.field]="col.field">
            {{ col.header | translate }}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>

      <!-------------------------------------- Table Body Part ---------------------------------------------->
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData" [pEditableRow]="rowData" (click)="onRowSelect(rowData)">
          <ng-container [ngSwitch]="col.field" *ngFor="let col of columns">

            <!-------------------------------------- AwbNumber Column ---------------------------------------------->
            <td *ngSwitchCase="'awbNumber'">
              <div class="overflow-text">
                {{ rowData[col.field] | replaceNullWith: '-' }}
              </div>
            </td>

            <!-------------------------------------- consigneeCountryCode Column ---------------------------------------------->
            <td *ngSwitchCase="'consigneeCountryCode'">
              <div class="overflow-text">
                {{ rowData[col.field] | replaceNullWith: '-' }}
              </div>
            </td>

            <!-------------------------------------- ConsigneeCity Column ---------------------------------------------->
            <td *ngSwitchCase="'consigneeCity'">
              <div class="overflow-text">
                {{ rowData[col.field] | replaceNullWith: '-' }}
              </div>
            </td>

            <!-------------------------------------- ConsigneeCityMappingLaaSCity Column ---------------------------------------------->
            <td *ngSwitchCase="'consigneeCityMappingLaaSCity'">
              <p-cellEditor class="p-fluid">
                <ng-template pTemplate="input">
                  <p-dropdown
                    appendTo="body"
                    inputId="consigneeCityMappingLaaSCity"
                    placeholder="{{ 'DHLCityMaintenance.Placeholder.OptionHint.SelectACity' | translate }}"
                    [showClear]="true"
                    [filter]="true"
                    [options]="getCityOptions(rowData.consigneeCountryCode)"
                    [(ngModel)]="rowData.consigneeCityMappingLaaSCity"
                  ></p-dropdown>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: "-" }}
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>

            <!-------------------------------------- shipperCountryCode Column ---------------------------------------------->
            <td *ngSwitchCase="'shipperCountryCode'">
              <div class="overflow-text">
                {{ rowData[col.field] | replaceNullWith: '-' }}
              </div>
            </td>

            <!-------------------------------------- ShipperCity Column ---------------------------------------------->
            <td *ngSwitchCase="'shipperCity'">
              <div class="overflow-text">
                {{ rowData[col.field] | replaceNullWith: '-' }}
              </div>
            </td>

            <!-------------------------------------- ShipperCityMappingLaaSCity Column ---------------------------------------------->
            <td *ngSwitchCase="'shipperCityMappingLaaSCity'">
              <p-cellEditor class="p-fluid">
                <ng-template pTemplate="input">
                  <p-dropdown
                    appendTo="body"
                    inputId="shipperCityMappingLaaSCity"
                    placeholder="{{ 'DHLCityMaintenance.Placeholder.OptionHint.SelectACity' | translate }}"
                    [showClear]="true"
                    [filter]="true"
                    [options]="getCityOptions(rowData.shipperCountryCode)"
                    [(ngModel)]="rowData.shipperCityMappingLaaSCity"
                    
                  ></p-dropdown>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: "-" }}
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>

            <!-------------------------------------- ErrorMsg Column ---------------------------------------------->
            <td *ngSwitchCase="'errorMsg'">
              <div class="overflow-text">
                {{ rowData[col.field] | replaceNullWith: '-' }}
              </div>
            </td>

          </ng-container>
        </tr>
      </ng-template>

      <!-------------------------------------- Table Empty Message Part ---------------------------------------------->
      <!-------------------------------------- Message for empty table ---------------------------------------------->
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length">
            {{ "Common.Table.NoData" | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>

  </p-card>
</div>
<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
